import React, { Component } from 'react';
import { array, arrayOf, func, object, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';

import { useIntl, intlShape, FormattedMessage } from '../../util/reactIntl';
import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';

import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import {
  isOriginInUse,
} from '../../util/search';
import { createSlug } from '../../util/urlHelpers';
import { propTypes } from '../../util/types';
import { getListingsById, getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/ui.duck';

import {
  Button,
  CartPanel,
  Footer,
  Page,
  PaginationLinks
} from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import { setActiveListing } from '../../containers/SearchPage/SearchPage.duck';
import {
  searchParamsPicker,
  validUrlQueryParamsFromProps,
  createSearchResultSchema,
} from '../../containers/SearchPage/SearchPage.shared';


import css from './CartPage.module.css';
import { initializeCardPaymentData } from '../../ducks/stripe.duck';
import { fetchTransactionLineItems } from '../ListingPage/ListingPage.duck';

const formatPrice = value => {
  if (value === null || value === undefined) {
    return '0.00';
  }
  const str = typeof value === 'number' ? value.toFixed(2) : String(value);
  const parts = str.split('.');
  if (parts.length > 2 && parts[parts.length - 1] === '00') {
    return parts.slice(0, -1).join('.');
  }
  return str;
};
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { types as sdkTypes } from '../../util/sdkLoader';


const { UUID, Money } = sdkTypes;
export class CartPageComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSearchMapOpenOnMobile: props.tab === 'map',
      isMobileModalOpen: false,
      currentQueryParams: validUrlQueryParamsFromProps(props),
      isSecondaryFiltersOpen: false,
      bookmarks: props && props.bookmarks && props.bookmarks.length ? props.bookmarks : [],
      stockCount: 1,
      stockListing: null,
      stockDetails: [],
      buttonIndex: -1,
      resetState: false,
      sd: []
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleWishlist = this.handleWishlist.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleMinus = this.handleMinus.bind(this);
    this.removeFromState = this.removeFromState.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.buttonIndex !== this.state.buttonIndex) {
      this.setState({ resetState: true });
    }
    const { isAuthenticated, getListing, currentUser } = this.props;
    const bookmarks = currentUser?.attributes?.profile?.publicData?.bookmarks;

    if (
      isAuthenticated &&
      this.state.stockDetails &&
      this.state.stockDetails.length <= 0 &&
      currentUser &&
      currentUser.id
    ) {
      bookmarks &&
        bookmarks.map(item => {
          const listingId = new UUID(item.id);
          const listing = getListing(listingId);

          if (listing && listing.id && listing.id.uuid) {
            this.handleAdd({ ...listing, quantity: Number(item.quantity) });
          }
        });
    } else if (this.state.stockDetails && this.state.stockDetails.length <= 0) {
      let localBookmarks =
        typeof window !== 'undefined' &&
          window.localStorage.getItem('localBookmarks') &&
          window.localStorage.getItem('localBookmarks').length > 0
          ? window.localStorage.getItem('localBookmarks')
          : [];

      if (typeof localBookmarks === 'string') {
        localBookmarks =
          typeof window !== 'undefined' &&
          window.localStorage &&
          JSON.parse(window.localStorage.getItem('localBookmarks'));
      }

      localBookmarks &&
        localBookmarks.forEach(item => {
          const listingId = new UUID(item.id);
          const listing = getListing(listingId);
          if (listing) {
            return this.handleAdd({ ...listing, quantity: Number(item.quantity) });
          }
        });
    }
  }

  handleSubmit(combinedListings, ind) {
    const { history, callSetInitialValues, onInitializeCardPaymentData, getListing, routeConfiguration, currentUser } = this.props;
    const cartListings = combinedListings && combinedListings[ind] && combinedListings[ind].flat();
    this.setState({ buttonIndex: ind });
    const cartListingsIds = cartListings && cartListings.map(item => item.id.uuid);

    const vendorListing = cartListings && cartListings[0];
    const vendorId =
      vendorListing &&
      vendorListing.attributes &&
      vendorListing.attributes.publicData &&
      vendorListing.attributes.publicData.vendorId;

    const listingId = new UUID(vendorId);
    const listing = vendorListing;
    const bookingDatesMaybe = {};
    const bookmarksDeliveryMethod = currentUser && currentUser.attributes.profile.publicData.bookmarks.filter((st) => cartListingsIds?.includes(st.id));
    const discountedPrice = currentUser && currentUser.attributes.profile.publicData.bookmarks.filter((st) => cartListingsIds?.includes(st.id));

    const shownAttributes = currentUser && currentUser.attributes.profile.publicData.bookmarks.filter((st) => cartListingsIds?.includes(st.id));



    let sd = this.state.sd;

    cartListings &&
      cartListings.forEach(item => {
        const { currentStock } = item || {}
        const discountedPriceIndex =
          discountedPrice && discountedPrice.findIndex(e => e.id === item.id.uuid);
        const discount = discountedPrice[discountedPriceIndex]?.discountedPrice;
        const changedPrice = discount
          ? new Money(discount, 'USD')
          : null;
        const price = changedPrice
          ? changedPrice
          : item && item?.attributes && item?.attributes?.price;
        const title = item && item.attributes && item.attributes.title;
        const images = item && item.images;
        const authorId = item && item.author;
        const quantity =
          currentStock && currentStock.attributes && currentStock.attributes.quantity;

        const publicData = item && item.attributes && item.attributes.publicData;
        const shippingPriceInSubunitsOneItem =
          publicData && publicData.shippingPriceInSubunitsOneItem;
        const shippingPriceInSubunitsAdditionalItems =
          publicData && publicData.shippingPriceInSubunitsAdditionalItems;
        const currency = price && price.currency;
        // const changedPrice =

        // const indexColor =
        // bookmarksColor &&
        // bookmarksColor.findIndex(e => e.id === item.id.uuid);

        // const indexSize =
        // bookmarksSize &&
        // bookmarksSize.findIndex(e => e.id === item.id.uuid);
        const cartAttributes =
          shownAttributes && shownAttributes.findIndex(e => e.id === item.id.uuid);

        const deliveryMethodIndex =
          bookmarksDeliveryMethod && bookmarksDeliveryMethod.findIndex(e => e.id === item.id.uuid);

        const index =
          this.state.stockDetails &&
          this.state.stockDetails.findIndex(e => e.listingId === item.id.uuid);
        const selectedItem = this.state.stockDetails && this.state.stockDetails[index];

        return sd.push({
          // customCommission,
          listingId: item.id.uuid,
          stockCount: selectedItem ? selectedItem.stockCount : 1,
          // color:bookmarksColor[indexColor]?.color,
          // size:bookmarksSize[indexSize]?.size,
          finalAttributes: shownAttributes[cartAttributes]?.modifiedObject,
          oldStock: quantity,
          deliveryMethod: bookmarksDeliveryMethod[deliveryMethodIndex].deliveryMethod,
          price,
          title,
          authorId,
          shippingPriceInSubunitsOneItem,
          shippingPriceInSubunitsAdditionalItems,
          currency,
          images,
        });
      });

    const initialValues = {
      listing: vendorListing,
      orderData: {
        ...bookingDatesMaybe,
        quantity: Number.parseInt(sd[0]?.stockCount, 10),
        // deliveryMethod: 'shipping',
        otherOrderData: {
          cartItems: sd,
        },
      },
      confirmPaymentError: null,
    };
    const saveToSessionStorage = !this.props.currentUser;

    const routes = routeConfiguration;
    // Customize checkout page state with current listing and selected orderData
    const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);

    callSetInitialValues(setInitialValues, initialValues, saveToSessionStorage);

    // Clear previous Stripe errors from store if there is any
    onInitializeCardPaymentData();

    // Redirect to CheckoutPage
    history.push(
      createResourceLocatorString(
        'CheckoutPage',
        routes,
        {
          id: listing.id.uuid,
          slug: createSlug(listing.attributes.title),
          tab: 'paypal',
        },
        {}
      )
    );
  }

  removeFromState(id) {
    const index = this.state.stockDetails.findIndex(item => item.listingId == id);
    this.state.stockDetails && this.state.stockDetails.splice(index, 1);
    // this.setState({ stockDetails: this.state.stockDetails });
  }

  handleWishlist(id, e) {
    const { onUpdateProfile, currentUser, isAuthenticated } = this.props;
    const bookmarks = currentUser?.attributes?.profile?.publicData?.bookmarks;

    e.preventDefault();
    e.stopPropagation();

    if (!isAuthenticated && e && id) {
      let localBookmarks =
        typeof window !== 'undefined' &&
          window.localStorage.getItem('localBookmarks') &&
          window.localStorage.getItem('localBookmarks').length > 0
          ? window.localStorage.getItem('localBookmarks')
          : [];

      if (typeof localBookmarks === 'string') {
        localBookmarks =
          typeof window !== 'undefined' &&
          window.localStorage &&
          JSON.parse(window.localStorage.getItem('localBookmarks'));
      }

      const localIndex = localBookmarks && localBookmarks.findIndex(b => b.id == id);
      // const hasItem = localBookmarks && localBookmarks.find(e => e.id == id);

      if (localIndex > -1) {
        let bookmarks = localBookmarks.filter(e => e.id != id);
        localBookmarks && localBookmarks.splice(localIndex, 1);
        const removedBookmarks = Array.from(new Set(bookmarks));
        typeof window !== 'undefined' &&
          window.localStorage.setItem('localBookmarks', JSON.stringify(removedBookmarks));
      } else {
        localBookmarks.push(id);
        const addedBookmarks = Array.from(new Set(localBookmarks));
        typeof window !== 'undefined' &&
          window.localStorage.setItem('localBookmarks', JSON.stringify(addedBookmarks));
      }
    }

    const index = bookmarks && bookmarks.findIndex(b => b.id == id);

    if (isAuthenticated) {
      typeof window !== 'undefined' && window.localStorage.removeItem('localBookmarks');
    }

    if (id) {
      if (index > -1) {
        bookmarks && bookmarks.splice(index, 1);
        const removedBookmarks = Array.from(new Set(bookmarks));
        const profile = {
          publicData: {
            bookmarks: removedBookmarks,
          },
        };
        onUpdateProfile(profile);
      } else {
        bookmarks && bookmarks.push(id);
        const addedBookmarks = Array.from(new Set(this.state.bookmarks));
        const profile = {
          publicData: {
            bookmarks: addedBookmarks,
          },
        };
        onUpdateProfile(profile);
      }
    }
  }

  handleAdd(listing) {
    const currentStock = listing && listing.currentStock;
    const price = listing && listing.attributes && listing.attributes.price;
    const title = listing && listing.attributes && listing.attributes.title;
    const authorId = listing && listing.author && listing.author.id && listing.author.id.uuid;
    const quantity = currentStock && currentStock.attributes && currentStock.attributes.quantity;

    const publicData = listing && listing.attributes && listing.attributes.publicData;
    const shippingPriceInSubunitsOneItem = publicData && publicData.shippingPriceInSubunitsOneItem;
    const shippingPriceInSubunitsAdditionalItems =
      publicData && publicData.shippingPriceInSubunitsAdditionalItems;
    const currency = price && price.currency;
    const selectedQuantity = listing?.quantity;

    const index =
      this.state.stockDetails &&
      this.state.stockDetails.findIndex(item => item.listingId == listing.id.uuid);
    if (index == -1) {
      const details = {
        listingId: listing.id.uuid,
        stockCount: selectedQuantity,
        price,
        title,
        authorId,
        shippingPriceInSubunitsOneItem,
        shippingPriceInSubunitsAdditionalItems,
        currency,
      };
      this.state.stockDetails.push(details);
      this.setState({ stockDetails: this.state.stockDetails });
    } else {
      if (this.state.stockDetails[index].stockCount < quantity) {
        const st = (this.state.stockDetails[index].stockCount =
          this.state.stockDetails[index].stockCount + 1);
        const details = {
          listingId: listing.id.uuid,
          stockCount: st,
          price,
          title,
          authorId,
          shippingPriceInSubunitsOneItem,
          shippingPriceInSubunitsAdditionalItems,
          currency,
        };
        this.state.stockDetails[index] = details;
        this.setState({ stockDetails: this.state.stockDetails });
      }
    }
  }

  handleMinus(listing) {
    const currentStock = listing && listing.currentStock;
    const price = listing && listing.attributes && listing.attributes.price;
    const title = listing && listing.attributes && listing.attributes.title;
    const authorId = listing && listing.author && listing.author.id && listing.author.id.uuid;
    const quantity = currentStock && currentStock.attributes && currentStock.attributes.quantity;

    const publicData = listing && listing.attributes && listing.attributes.publicData;
    const shippingPriceInSubunitsOneItem = publicData && publicData.shippingPriceInSubunitsOneItem;
    const shippingPriceInSubunitsAdditionalItems =
      publicData && publicData.shippingPriceInSubunitsAdditionalItems;
    const currency = price && price.currency;

    const index =
      this.state.stockDetails &&
      this.state.stockDetails.findIndex(item => item.listingId == listing.id.uuid);

    if (
      index > -1 &&
      this.state.stockDetails &&
      this.state.stockDetails.length &&
      this.state.stockDetails[index].stockCount > 1
    ) {
      const st = (this.state.stockDetails[index].stockCount =
        this.state.stockDetails[index].stockCount - 1);
      const details = {
        listingId: listing.id.uuid,
        stockCount: st,
        price,
        title,
        authorId,
        shippingPriceInSubunitsOneItem,
        shippingPriceInSubunitsAdditionalItems,
        currency,
      };
      this.state.stockDetails[index] = details;
      this.setState({ stockDetails: this.state.stockDetails });
    }
  }


  render() {
    const {
      intl,
      listings,
      location,
      scrollingDisabled,
      searchParams,
      routeConfiguration,
      config,
      currentUser,
      isAuthenticated,
      pagination,
      queryInProgress,
      queryParams,
      bookmarks,
    } = this.props;
    
    const hasPaginationInfo = !!pagination && pagination.totalItems != null;
    const listingsAreLoaded = !queryInProgress && hasPaginationInfo;

    const noResults =
      listingsAreLoaded && listings && listings.length === 0 ? (
        <h1 className={css.title}>
          <FormattedMessage id="CartPage.noResults" />
        </h1>
      ) : null;

    const heading =
      listingsAreLoaded && listings && listings.length > 0 ? (
        <h1 className={css.title}>
          <FormattedMessage id="CartPage.youHaveListings" />
        </h1>
      ) : (
        noResults
      );

    const page = queryParams ? queryParams.page : 1;
    const paginationLinks =
      listingsAreLoaded && listings && listings.length > 24 ? (
        <PaginationLinks
          className={css.pagination}
          pageName="CartPage"
          pageSearchParams={{ page }}
          pagination={pagination}
        />
      ) : null;


    const { listingFields: listingFieldsConfig } = config?.listing || {};
    const { defaultFilters: defaultFiltersConfig, sortConfig } = config?.search || {};
    const { urlQueryParams, searchParamsInURL } = searchParamsPicker(
      location.search,
      searchParams,
      listingFieldsConfig,
      defaultFiltersConfig,
      sortConfig,
      isOriginInUse(config)
    );

    const { title, description, schema } = createSearchResultSchema(
      listings,
      searchParamsInURL || {},
      intl,
      routeConfiguration,
      config
    );

    // Set topbar class based on if a modal is open in
    // a child component
    const topbarClasses = this.state.isMobileModalOpen
      ? classNames(css.topbarBehindModal, css.topbar)
      : css.topbar;

    const cardRenderSizes = isMapVariant => {
      if (isMapVariant) {
        // Panel width relative to the viewport
        const panelMediumWidth = 50;
        const panelLargeWidth = 62.5;
        return [
          '(max-width: 767px) 100vw',
          `(max-width: 1023px) ${panelMediumWidth}vw`,
          `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
          `${panelLargeWidth / 3}vw`,
        ].join(', ');
      } else {
        // Panel width relative to the viewport
        const panelMediumWidth = 50;
        const panelLargeWidth = 62.5;
        return [
          '(max-width: 549px) 100vw',
          '(max-width: 767px) 50vw',
          `(max-width: 1439px) 26vw`,
          `(max-width: 1920px) 18vw`,
          `14vw`,
        ].join(', ');
      }
    };


    const arrKeys = listings && listings.length && [...new Set(listings.map(st => st.author.id.uuid))];
    const combinedListings = arrKeys && arrKeys.length && arrKeys.map(item => listings.reduce((acc, curr) => curr.author?.id?.uuid == item ? [...acc, curr] : [...acc], []));

    const getAuthorName = cl => {
      const authorName =
        cl &&
        cl[0] &&
        cl[0].author &&
        cl[0].author.attributes &&
        cl[0].author.attributes.profile &&
        cl[0].author.attributes.profile.displayName;
      return authorName;
    };

    const getTotalPrice = (cl, currentUser) => {
      const clUuids = cl.map((listing) => listing.id.uuid);
      const filteredBookmarks = currentUser?.attributes.profile.publicData.bookmarks.filter((bookmark) =>
        clUuids.includes(bookmark.id)
      );

      const matchedListingsArr =
        this.state.stockDetails &&
        this.state.stockDetails.map(item => {
          const index = cl && cl.findIndex(c => c.id.uuid === item.listingId);
          if (index > -1) {
            return item;
          }
        });

      const matchedListings = matchedListingsArr && matchedListingsArr.filter(item => item);
      const newMatchedListings = filteredBookmarks && filteredBookmarks.filter(item => item);

      let linePrices = [];
      matchedListings &&
        matchedListings.forEach(item => {
          const totalSinglePrice = (item.price?.amount / 100) * item.stockCount;
          return linePrices.push(totalSinglePrice);
        });

      let newLinePrices = [];
      newMatchedListings &&
        newMatchedListings.forEach(item => {
          const correspondingStockDetail = this.state.stockDetails.find(stockItem => stockItem.listingId === item.id);
          if (correspondingStockDetail) {
            const priceToUse = item.discountedPrice !== null ? item.discountedPrice / 100 : correspondingStockDetail.price.amount / 100;
            const totalSinglePrice1 = priceToUse * correspondingStockDetail.stockCount;
            return newLinePrices.push(totalSinglePrice1);
          }
        });

      const sum = newLinePrices.length > 0 ? newLinePrices.reduce((partialSum, a) => partialSum + a, 0) : linePrices.reduce((partialSum, a) => partialSum + a, 0);
      return sum;
    };

    const getTotalItems = cl => {
      let stockDetails =
        this.state.stockDetails && this.state.stockDetails.length > 0
          ? this.state.stockDetails
          : [];

      const total =
        cl &&
        cl.map(e => {
          const index = stockDetails && stockDetails.findIndex(item => item.listingId == e.id.uuid);
          const sum = [];
          if (index > -1) {
            const stock = stockDetails && stockDetails[index];
            const count = stock && stock.stockCount;
            sum.push(count);
          } else {
            const count = 1;
            sum.push(count);
          }
          return sum;
        });

      const totalItems =
        total && total.flat() && total.flat().reduce((partialSum, a) => partialSum + a, 0);
      return totalItems;
    };

    const lb =
      typeof window !== 'undefined' &&
      window.localStorage &&
      typeof window.localStorage.getItem('localBookmarks') === 'string' &&
      JSON.parse(window.localStorage.getItem('localBookmarks'));

    const localBookmarks =
      typeof window !== 'undefined' &&
      window.localStorage &&
      typeof window.localStorage.getItem('localBookmarks') === 'string' &&
      JSON.parse(window.localStorage.getItem('localBookmarks')).map(e => e.id);

    const topbar = <TopbarContainer lb={lb} />;

    return (
      <Page
        scrollingDisabled={scrollingDisabled}
        description={description}
        title={title}
        schema={schema}
      >
        <TopbarContainer
          className={topbarClasses}
          currentPage="SearchPage"
          currentSearchParams={urlQueryParams}
        />
        <div className={css.listingCards}>
          {(isAuthenticated && bookmarks && bookmarks.length) ||
            (!isAuthenticated && lb && lb.length)
            ? combinedListings &&
            combinedListings.map((cl, i) => (
              <div className={css.vendor}>
                <div className={css.venderCards}>
                  {cl.map((l, i) => (
                    <CartPanel
                      className={css.listingCard}
                      key={i}
                      listing={l}
                      renderSizes={cardRenderSizes(false)}
                      setActiveListing={() => { }}
                      handleWishlist={this.handleWishlist}
                      bookmarks={!isAuthenticated ? localBookmarks : bookmarks}
                      showAuthorInfo={true}
                      handleAdd={() => this.handleAdd(l)}
                      handleMinus={() => this.handleMinus(l)}
                      stockDetails={this.state.stockDetails}
                      handleRemoveFromState={this.removeFromState}
                      currentUser={currentUser}
                    />
                  ))}
                </div>
                <div className={css.checkoutSection}>
                  <div className={css.priceBreakdown}>
                    <div>
                      <p>Cart with {getAuthorName(cl)}</p>
                    </div>
                    <div className={css.totalPrice}>
                      <p>Subtotal</p>
                      <h6>${formatPrice(getTotalPrice(cl, currentUser))}</h6>
                    </div>
                    <div className={css.totalItems}>
                      <p> Total Items ({getTotalItems(cl)})</p>
                    </div>
                  </div>
                  <div className={css.checkoutButton}>
                    <Button onClick={() => this.handleSubmit(combinedListings, i)}>
                      Checkout
                    </Button>
                  </div>
                </div>
              </div>
            ))
            : null}
        </div>
        <Footer />
      </Page>
    );
  }
}

CartPageComponent.defaultProps = {
  listings: [],
  pagination: null,
  searchListingsError: null,
  searchParams: {},
  tab: 'listings',
  activeListingId: null,
};

CartPageComponent.propTypes = {
  listings: array,
  history: shape({
    push: func.isRequired,
  }).isRequired,
  // from useLocation
  location: shape({
    search: string.isRequired,
  }).isRequired,

  // from useIntl
  intl: intlShape.isRequired,

  // from useConfiguration
  config: object.isRequired,

  // from useRouteConfiguration
  routeConfiguration: arrayOf(propTypes.route).isRequired,
};

const EnhancedSearchPage = props => {
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();

  return (
    <CartPageComponent
      config={config}
      routeConfiguration={routeConfiguration}
      intl={intl}
      history={history}
      location={location}
      {...props}
    />
  );
};

const mapStateToProps = state => {
  const {
    showListingError,
    reviews,
    fetchReviewsError,
    timeSlots,
    fetchTimeSlotsError,
    sendEnquiryInProgress,
    sendEnquiryError,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    enquiryModalOpenForListingId,
    currentPageResultIds,
    pagination,
    queryInProgress,
    queryListingsError,
    queryParams,
  } = state.SectionHeroPage;
  const { currentUser } = state.user;
  const { isAuthenticated } = state.auth;
  
  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const bookmarks =
    currentUser &&
    currentUser?.attributes &&
    currentUser?.attributes?.profile &&
    currentUser?.attributes?.profile?.publicData &&
    currentUser?.attributes?.profile?.publicData?.bookmarks?.map(e => e.id);


  const ownBookmarks =
    bookmarks && currentPageResultIds
      ? currentPageResultIds.filter(item => bookmarks.indexOf(item.uuid) !== -1)
      : [];

  const localBookmarks =
    typeof window !== 'undefined' &&
    typeof window.localStorage.getItem('localBookmarks') === 'string' &&
    JSON.parse(window.localStorage.getItem('localBookmarks')).map(e => e.id);

  const ownLocalBookmarks =
    localBookmarks && currentPageResultIds
      ? currentPageResultIds.filter(item => localBookmarks.indexOf(item.uuid) !== -1)
      : [];
  const listings = ownBookmarks
    ? getListingsById(state, ownLocalBookmarks.length > 0 ? ownLocalBookmarks : ownBookmarks)
    : null;

  const featuredListings = currentPageResultIds
    ? getListingsById(state, currentPageResultIds)
    : null;

  const filteredFl = featuredListings.filter(
    item =>
      item.attributes &&
      item.attributes.title &&
      item.attributes.title.includes('Vendor Listing') !== true
  );

  return {
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    scrollingDisabled: isScrollingDisabled(state),
    enquiryModalOpenForListingId,
    showListingError,
    reviews,
    fetchReviewsError,
    timeSlots,
    fetchTimeSlotsError,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    sendEnquiryInProgress,
    sendEnquiryError,
    bookmarks,
    currentUser,
    currentPageResultIds,
    featuredListings: filteredFl,
    listings,
    pagination,
    queryInProgress,
    queryListingsError,
    queryParams,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onActivateListing: listingId => dispatch(setActiveListing(listingId)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),
  onSendEnquiry: (listingId, message) => dispatch(sendEnquiry(listingId, message)),
  onFetchTransactionLineItems: params => dispatch(fetchTransactionLineItems(params)),
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CartPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(EnhancedSearchPage);

CartPage.loadData = (params, search) => {
  const queryParams = parse(search);
  const page = queryParams.page || 1;
  return searchListings({
    ...queryParams,
    page,
    perPage: RESULT_PAGE_SIZE,
    include: ['author', 'images'],
    'fields.listing': ['title', 'geolocation', 'price', 'publicData', 'createdAt'],
    'fields.user': ['profile', 'profile.displayName', 'profile.abbreviatedName'],
    'fields.image': ['variants.landscape-crop', 'variants.landscape-crop2x'],
    'limit.images': 1,
  });
};

export default CartPage;
